import { render, staticRenderFns } from "./OrgSelector.vue?vue&type=template&id=8e4a5ac0&scoped=true&"
import script from "./OrgSelector.vue?vue&type=script&lang=js&"
export * from "./OrgSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e4a5ac0",
  null
  
)

export default component.exports